<div class="page-container" [class.loading]="isLoading">
    <app-header [title]="'payroll.taxReturns.records'" [menuService]="payrollModuleMenuService"></app-header>

    <div class="flex justify-space-between align-items-center padding-bottom-3">
        <mat-form-field class="no-labels no-helpers">
            <mat-select [(ngModel)]="selectedYear" (selectionChange)="onYearChange()">
                <mat-option *ngFor="let year of taxYears" [value]="year">{{ year }}</mat-option>
            </mat-select>
        </mat-form-field>
        <div>{{ 'payroll.taxReturns.craBusinessNumber' | translate }}{{ craBusinessNumber }}</div>
    </div>

    @if (isTaxPortalOpen) {
        @if (table) {
            <app-table
                [table]="table"
                [title]="'table.taxReturns.taxReturns' | translate"
                [showSearch]="false"
                [useStickyHeader]="false"
                [showOffset]="false"
                (rowClicked)="!$event.id && generateTaxReturn()"
            >
            </app-table>
        }
    } @else {
        <ui-banner variant="info"
            ><div
                [innerHtml]="
                    'payroll.taxReturns.taxFormsWillBeAvailableStarting'
                        | translate: { year: selectedYear, date: taxPortalDate | appDate: 'MMMM d, yyyy' }
                "
            ></div>
        </ui-banner>
    }
</div>
